import { safeLocalStorage } from 'utils/storage';

const FORCE_ICE_RELAY_KEY = 'debug:forceIceRelay';

// Lets QA/support force relay-only ICE for a single client via console; ungated so a meeting and the system check agree.
export const isForceIceRelayLeverSet = (): boolean =>
  safeLocalStorage.getItem(FORCE_ICE_RELAY_KEY) === '1';
